import { afterNextRender, ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DateTime } from 'luxon';
import { AuthService } from '../../../auth.service';
import { ProfileService } from '../../profile/profile.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { PaintDirective } from '../../../paint.directive';
import { DatePipe } from '@angular/common';
import { LocationService } from '../../../location.service';

@Component({
	selector: 'refer-a-friend',
	templateUrl: './referral.component.html',
	styleUrls: ['./referral.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIconModule,MatButtonModule,MatDividerModule,PaintDirective,RouterLink,DatePipe]
})
export default class ReferralComponent {
	auth = inject(AuthService);
	service = inject(ProfileService);
	activated = inject(ActivatedRoute);
	router = inject(LocationService);
	destroy = inject(DestroyRef);

	friend = signal<string>('Your friend');
	code = signal<string>('');
	expiry = signal<Date>(DateTime.now().plus({ days: 7 }).toJSDate());

	constructor() {

		afterNextRender(() => {
			this.router.initialURL?.searchParams.append('is_referral', 'yearly');
	
			this.code.set(this.router.initialURL?.searchParams.get('code') ?? '');
	
			if(this.code){
				if(this.auth.userSession()){
					this.service.addCoupon(this.code(), 'yearly').pipe(takeUntilDestroyed(this.destroy)).subscribe(use => {
						if(use.expiry){
							this.expiry.set(DateTime.fromISO(use.expiry).toJSDate());
						}
					});
				}
	
				const referrer = this.router.initialURL?.searchParams.get('referrer');
				
				if(referrer){
					this.friend.set(referrer);
				} else {
					this.service.getReferrer(this.code()).pipe(takeUntilDestroyed(this.destroy)).subscribe(user => {
						this.friend.set(user?.name ?? 'Your friend');
					});
				}
			}
		})
	}

}
